import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, FormGroup, Label, Input, Card, Col, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import ReactTable from "react-table";
import SaveTaskDetailsService from "../../../../../../../Service/OPSServices/WorkflowsService/SaveTaskDetailsService";
import CustomModal from "../../../../../../Components/Modals/CustomModal";
import { SetInnerHtmlWithClassReplacement } from "../../../../../../../Utils/Constants";
import { connect } from "react-redux";

function UpdatedTaskDetailsPreviewMode(props) {
  const [satusLoading, setSatusLoading] = useState(false);
  const [assignedLoading, setAssingedLoading] = useState(false);
  const [assignedDropdownOpen, setAssignedDropdownOpen] = useState({});
  const [selectedAssignedTo, setSelectedAssignedTo] = useState({});
  const [latestCommentPopup, setLatestCommentPopup] = useState(false);
  const [latestComment, setLatestComment] = useState("");
  const [expandedPhases, setExpandedPhases] = useState({});
  const [assignedFilter, setAssignedFilter] = useState("");

  const togglePhase = (phaseId) => {
    setExpandedPhases(prev => ({
      ...prev,
      [phaseId]: !prev[phaseId]
    }));
  };

  const toggleAssignedDropdown = (taskId) => {
    setAssignedDropdownOpen(prevState => ({
      ...prevState,
      [taskId]: !prevState[taskId]
    }));
  };

  const saveTaskDetails = (type, value, taskDetailsToSave) => {
    console.log('saveTaskDetails')
    if (!taskDetailsToSave) return;

    let data;
   if (type === 'assignedTo') {
      setAssingedLoading(taskDetailsToSave.id);
     
      data = {
        taskId: taskDetailsToSave.id,
        taskText: 'assignedTo',
        workflowMasterId: props.selectedWorkflowMasterId,

         assignedTo:
        value !== undefined
          ? value.split(',')
          : (
              taskDetailsToSave &&
              taskDetailsToSave.answerObject &&
              taskDetailsToSave.answerObject[0] &&
              taskDetailsToSave.answerObject[0].executor
            )
              ? taskDetailsToSave.answerObject[0].executor.split(',')
              : [],// value !== undefined ? value : (taskDetailsToSave.answerObject && taskDetailsToSave.answerObject[0] ? taskDetailsToSave.answerObject[0].executor : 0),
       
        workflowPhaseId: taskDetailsToSave.WorkflowPhases,
        integerId: props.selectedStoreData ? props.selectedStoreData.integerId : "",
        status: (taskDetailsToSave.answerObject && taskDetailsToSave.answerObject[0]) ? taskDetailsToSave.answerObject[0].status : 0,
        attachmentFile: [],
        brand: props.selectedProjectData ? props.selectedProjectData.brandId : '',
        project: props.selectedProjectData ? props.selectedProjectData.projectId : '',
      };
      console.log(data)
    } else if (type === 'status') {
     
      var assignedTo = [];

      if (
        taskDetailsToSave &&
        taskDetailsToSave.answerObject &&
        taskDetailsToSave.answerObject.length > 0 &&
        taskDetailsToSave.answerObject[0] &&
        taskDetailsToSave.answerObject[0].executor
      ) {
        var executor = taskDetailsToSave.answerObject[0].executor;
    
        if (Array.isArray(executor)) {
          assignedTo = executor;
        } else {
          assignedTo = String(executor)
            .split(',')
            .filter(function(id) {
              return id && id !== '0';
            });
        }
      }
      setSatusLoading(taskDetailsToSave.id);
      data = {
        taskId: taskDetailsToSave.id,
        taskText: 'status',
        workflowMasterId: props.selectedWorkflowMasterId,
        assignedTo:assignedTo,
        workflowPhaseId: taskDetailsToSave.WorkflowPhases,
        integerId: props.selectedStoreData ? props.selectedStoreData.integerId : "",
        status: value ? value : ((taskDetailsToSave.answerObject && taskDetailsToSave.answerObject[0]) ? taskDetailsToSave.answerObject[0].status : 0),
        attachmentFile: [],
        brand: props.selectedProjectData ? props.selectedProjectData.brandId : '',
        project: props.selectedProjectData ? props.selectedProjectData.projectId : '',
      };
    } else {
      return;
    }

    SaveTaskDetailsService(props.token, data).then((res) => {
      if (res && res.status) {
        props.setTaskList(res.tasklist.tasklist);
        if(props.setWorkflowPhaseCount) props.setWorkflowPhaseCount(res.progressBarData.workflowPhasesCount);
        setSatusLoading(false);
        setAssingedLoading(false);
      }
    });
  };

  const handleStatusChange = (e, task) => {
    saveTaskDetails('status', e.target.value, task);
  };

  const handleAssignedCheckboxChange = (taskId, memberId, task) => {
    let currentSelected = selectedAssignedTo[taskId];

    if (currentSelected === undefined) {
      if (task && task.answerObject && task.answerObject[0] && task.answerObject[0].executor) {
        const executor = task.answerObject[0].executor;
        currentSelected = Array.isArray(executor) ? executor.map(Number) : String(executor).split(',').map(id => isNaN(id) ? id : Number(id));
      } else {
        currentSelected = [];
      }
    }

    let updatedMembers = [...currentSelected];
    const numericMemberId = Number(memberId);

    if (updatedMembers.includes(numericMemberId)) {
      updatedMembers = updatedMembers.filter(id => id !== numericMemberId);
    } else {
      updatedMembers.push(numericMemberId);
    }

    setSelectedAssignedTo(prev => ({ ...prev, [taskId]: updatedMembers }));
    const newValue = updatedMembers.length > 0 ? updatedMembers.join(',') : 0;
    saveTaskDetails('assignedTo', newValue, task);
  };

  const getSelectedAssignedNames = (taskId, teamMembersList, task) => {
    let selectedIds = selectedAssignedTo[taskId];

    if (selectedIds === undefined) {
      let executor = (task && task.answerObject && task.answerObject[0] && task.answerObject[0].executor)
        ? task.answerObject[0].executor
        : null;

      if (Array.isArray(executor)) {
        selectedIds = executor.map(Number);
      } else if (executor) {
        selectedIds = String(executor).split(',').map(id => isNaN(id) ? id : Number(id));
      } else {
        selectedIds = [];
      }
    }

    if (selectedIds.length === 0) return "-- Assigned to --";

    const assignedNames = (teamMembersList || [])
      .filter(member => selectedIds.includes(Number(member.employeeId)))
      .map(member => member.employeeName)
      .join(", ");
    return assignedNames.trim() === "" ? "-- Assigned to --" : assignedNames;
  };

  const viewLatestComment = (text) => {
    setLatestCommentPopup(true);
    setLatestComment(text || "");
  };

  const stripHtmlTags = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '');
  };

  const gridColumns = [
    {
      Header: "Task",
      accessor: "taskText",
      width: 400,
      Cell: (cellInfo) => (
        <div className="d-flex align-items-center w-100" style={{ overflow: "hidden", paddingLeft: "10px" }}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (props.handleOpenTaskDetailsPage) {
                props.handleOpenTaskDetailsPage(cellInfo.original);
              }
            }}
            style={{ color: "#3D85C6", textDecoration: "underline", width: "100%", textAlign: "left", overflow: "hidden" }}
            title={cellInfo.value}
          >
            <p
              className="m-0 comment-paragraph"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%"
              }}
            >
              {cellInfo.value}
            </p>
          </a>
        </div>
      ),
    },
    {
      Header: "Status",
      id: "status",
      width: 180,
      Cell: ({ original: task }) => {
        if (satusLoading === task.id) {
          return <p className="mb-0" style={{ color: "#81e94b" }}>Updating..</p>;
        }
        if (task.answerObject && task.answerObject[0] && task.answerObject[0].status === 6) {
          return (
            <div className="mt-1 d-flex flex-column align-items-center w-100">
              <span className="signedoff-dropdown w-75">
                Signed Off &nbsp; &nbsp; <FontAwesomeIcon style={{ color: "#fff" }} icon={faCheck} />
              </span>
              <p className="ml-2 mt-2 mb-0" style={{ color: "#333", fontSize: "13px" }}>
                {(() => {
                  let rawName = getSelectedAssignedNames(task.id, task.teamMembers || props.teamMembers, task);
                  
                  if (rawName === "-- Assigned to --") {
                    rawName = task.answerObject[0].executorName || task.answerObject[0].updatedByName || "";
                  }
                  
                  if (!rawName) return "";
                  
                  return rawName.split(", ").map(name => {
                    const parts = name.trim().split(" ");
                    return parts.length > 1 ? `${parts[0]} ${parts[1][0]}.` : parts[0];
                  }).join(", ");
                })()}
              </p>
            </div>
          );
        }

        const currentStatus = (task.answerObject && task.answerObject[0]) ? task.answerObject[0].status : null;
        const selectClass = currentStatus === 3 ? "inprogress-dropdown form-control"
                          : currentStatus === 5 ? "completed-dropdown form-control"
                          : currentStatus === 2 ? "notstarted-dropdown form-control"
                          : currentStatus === 1 ? "notapplicable-dropdown form-control"
                          : currentStatus === 4 ? "postpond-dropdown form-control"
                          : "form-control";

        return (
          <div className="d-flex justify-content-center w-100 ">
            <select
              className={`w-100 ${selectClass}`}
              value={currentStatus || ""}
              onChange={(e) => handleStatusChange(e, task)}
            >
              <option style={{ background: "#fff" }} value="">-- Select status --</option>
              {props.statusList && props.statusList.map((status) => (
                <option style={{ background: "#fff" }} key={status.id} value={status.id}>
                  {status.status}
                </option>
              ))}
            </select>
          </div>
        );
      }
    },
    {
      Header: "Due Date",
      id: "dueDate",
      width: 150,
      Cell: ({ original: task }) => {
        const dateValue =
          task.ageTask && task.ageTask.dueDate
            ? task.ageTask.dueDate.split("T")[0]
            : " ";

        const bgColor =
          task.ageTask && task.ageTask.colourCode
            ? task.ageTask.colourCode
            : "transparent";

        return (
          <div className="d-flex justify-content-center align-items-center w-100">
            <span
              className="due-date-pill"
              style={{ backgroundColor: bgColor }}
            >
              {dateValue}
            </span>
          </div>
        );
      },
    },
    {
      Header: "Responsible Team",
      id: "responsibleTeam",
      Cell: ({ original: task }) => {
        const rolesText = task.roleName && task.roleName.length > 0
          ? task.roleName.join(", ")
          : " ";

        return (
          <div className="d-flex justify-content-center w-100 ">
            <p 
              className="m-0 comment-paragraph text-center"
              title={rolesText}
            >
              {rolesText}
            </p>
          </div>
        );
      },
    },
    {
      Header: "Assigned To",
      id: "assignedTo",
      Cell: ({ original: task }) => {
        if (task.answerObject && task.answerObject[0] && task.answerObject[0].status === 6) {
          const assignedNames = getSelectedAssignedNames(task.id, task.teamMembers || props.teamMembers, task);
          return (
            <div className="d-flex justify-content-center w-100 ">
              <h6 className="ml-2 m-0">
                {assignedNames !== "-- Assigned to --" 
                  ? assignedNames 
                  : (task.answerObject[0].executorName || "")}
              </h6>
            </div>
          );
        }
        if (assignedLoading === task.id) {
          return (
            <div className="d-flex justify-content-center w-100 ">
              <p className="mb-0" style={{ color: "#81e94b" }}>Updating..</p>
            </div>
          );
        }

        const assignedNames = getSelectedAssignedNames(task.id, task.teamMembers || props.teamMembers, task);

        return (
          <div className="d-flex flex-column align-items-center w-100">
            <Dropdown
              isOpen={assignedDropdownOpen[task.id] || false}
              toggle={() => toggleAssignedDropdown(task.id)}
              className="w-100"
            >
              <DropdownToggle
                caret
                className="form-control d-flex justify-content-between align-items-center"
                style={{ backgroundColor: 'white', color: '#495057', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%' }}>
                  {assignedNames}
                </span>
              </DropdownToggle>
              <DropdownMenu 
                positionFixed={true} 
                container="body" 
                style={{ width: '250px', maxHeight: '200px', overflowY: 'auto', padding: '10px' }}
              >
                {(task.teamMembers || props.teamMembers || []).map((member) => (
                  <FormGroup check key={member.employeeId} className="m-2">
                    <Label check style={{ cursor: 'pointer', width: '100%' }}>
                      <Input
                        type="checkbox"
                        checked={
                          selectedAssignedTo[task.id] !== undefined
                            ? selectedAssignedTo[task.id].includes(Number(member.employeeId))
                            : ((task.answerObject && task.answerObject[0] && task.answerObject[0].executor)
                                ? String(task.answerObject[0].executor).split(',').map(id => isNaN(id) ? id : Number(id))
                                : []
                              ).includes(Number(member.employeeId))
                        }
                        onChange={() => handleAssignedCheckboxChange(task.id, member.employeeId, task)}
                      />
                      {member.employeeName}
                    </Label>
                  </FormGroup>
                ))}
              </DropdownMenu>
            </Dropdown>
            {assignedNames !== "-- Assigned to --" && (
              <div className="w-100 mt-1 marquee-container" style={{ padding: "4px 0" }}>
                <div className="marquee-text" style={{ color: "black", fontSize: "13px" }}>
                  {assignedNames}
                </div>
              </div>
            )}
          </div>
        );
      }
    },
    {
      Header: "Last Update",
      accessor: "lastModified",
      width: 120,
      Cell: (cellInfo) => {
        const val = cellInfo.value || "";
        let datePart = val;
        let timePart = "";
        
        if (val.includes("T")) {
          [datePart, timePart] = val.split("T");
          timePart = timePart.split(".")[0]; 
        } else if (val.includes(" ")) {
          [datePart, timePart] = val.split(" ");
        }

        return (
          <div className="d-flex flex-column justify-content-start align-items-start w-100 pl-2">
            <p className="m-0 comment-paragraph">{datePart}</p>
            {timePart && <p className="m-0 comment-paragraph">{timePart}</p>}
          </div>
        );
      },
    },
    {
      Header: "Latest Comment",
      id: "lastComment",
      Cell: ({ original: task }) => {
        const memoText = (task.answerObject && task.answerObject[0] && task.answerObject[0].memo)
          ? task.answerObject[0].memo
          : "";

        return (
          <div className="d-flex justify-content-center w-100 ">
            <p
              className="m-0 comment-paragraph-workflows"
              style={{ color: "#3D85C6", cursor: "pointer" }}
              onClick={() => viewLatestComment(memoText)}
            >
              {stripHtmlTags(memoText)}
            </p>
          </div>
        );
      }
    }
  ];

  const masterPhasesMap = {};
  const phasesList = props.workflowPhases || [];

  phasesList.forEach((phase) => {
    if (phase.WorkflowsMaster == props.selectedWorkflowMasterId) {
      const masterPhaseKey = phase.MasterPhase !== null && phase.MasterPhase !== undefined ? phase.MasterPhase : "null_phase";
      if (!masterPhasesMap[masterPhaseKey]) {
        masterPhasesMap[masterPhaseKey] = [];
      }
      masterPhasesMap[masterPhaseKey].push(phase);
    }
  });

  const gridComments = SetInnerHtmlWithClassReplacement ? SetInnerHtmlWithClassReplacement(latestComment) : latestComment;

  const renderSubPhases = (masterKey) => {
    const subPhases = masterPhasesMap[masterKey];
    if (!subPhases) return null;

    return subPhases.map((wp) => {
      const tasksForPhase = (props.taskList || []).filter(task => {
        const matchesPhase = task.WorkflowPhases === wp.id;

        let matchesAssignee = true;
        if (props.assignedMember) {
          const targetId = Number(props.assignedMember);

          if (selectedAssignedTo[task.id] !== undefined) {
            matchesAssignee = selectedAssignedTo[task.id].includes(targetId);
          } else if (task.answerObject && task.answerObject[0] && task.answerObject[0].executor) {
            const executor = task.answerObject[0].executor;
            if (Array.isArray(executor)) {
              matchesAssignee = executor.map(Number).includes(targetId);
            } else {
              matchesAssignee = String(executor)
                .split(',')
                .map(id => (isNaN(id) ? id : Number(id)))
                .includes(targetId);
            }
          } else {
            matchesAssignee = false;
          }
        }

        return matchesPhase && matchesAssignee;
      });

      if (tasksForPhase.length === 0) return null;

      const isFiltered = props.assignedMember && props.assignedMember !== "";
      const isOpen = isFiltered || (expandedPhases[wp.id] || false);

      return (
        <div key={wp.id} className="mb-3">
          <div
            onClick={() => togglePhase(wp.id)}
            className={`workflow-phase-header ${isOpen ? 'is-open' : ''}`}
          >
            <h6 className="m-0 workflow-phase-title"><b>{wp.name}</b></h6>
            <span className={`workflow-phase-arrow ${isOpen ? 'is-open' : ''}`}>
              <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 10.5V1.5C0 0.833333 0.7698 0.45523 1.3 0.85L9.1 5.35C9.56667 5.61667 9.56667 6.38333 9.1 6.65L1.3 11.15C0.7698 11.5448 0 11.1667 0 10.5Z" fill="#000000"/>
              </svg>
            </span>
          </div>

          {isOpen && (
            <ReactTable
              data={tasksForPhase}
              columns={gridColumns}
              className="-striped -highlight mt-2"
              getTheadProps={() => {
                return {
                  style: { overflowY: "hidden", background: "#B1FA63", color: "#243837" },
                };
              }}
              defaultPageSize={5}
              showPagination={true}
              noDataText={"No Tasks Found."}
            />
          )}
        </div>
      );
    });
  };

  const masterPhaseTabs = props.workflowMasterPhases || [];

  return (
    <>
      <Card className="card-min-height-workflows p-2 card-of-problemarea">
        <Col md={12} className="m-3">
          <h5 className="mb-4">
            <b>All Tasks</b>
          </h5>

          {masterPhaseTabs.map((masterTab) => {
             const masterId = String(masterTab.id);
             const displayMasterName = masterTab.phase ? masterTab.phase.toUpperCase() : `PHASE ${masterId}`;

             if (!masterPhasesMap[masterId] || masterPhasesMap[masterId].length === 0) return null;

             return (
              <div key={masterId} className="mb-4">
                 <h6 className="mb-3" style={{ borderBottom: "1px solid #e9ecef", paddingBottom: "5px" }}>
                   <b>{displayMasterName}</b>
                 </h6>

                {renderSubPhases(masterId)}
              </div>
            );
          })}
        </Col>
      </Card>

      <CustomModal
        header={"Latest Comment"}
        isOpen={latestCommentPopup}
        toggle={() => setLatestCommentPopup(!latestCommentPopup)}
        size={"lg"}
        className='curve-popup'
        footer={
          <>
            <Button color={"link"} onClick={() => setLatestCommentPopup(!latestCommentPopup)}>Cancel</Button>
          </>
        }
      >
        <Label>
          <p className="issue-discription-set" dangerouslySetInnerHTML={{ __html: gridComments }} />
        </Label>
      </CustomModal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
  };
};

export default connect(mapStateToProps)(UpdatedTaskDetailsPreviewMode);